var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"1000px"},on:{"mousemove":_vm.scroll,"mouseleave":_vm.scroll}},[_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions},on:{"mousemove":_vm.scroll,"mouseleave":_vm.scroll}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }